__webpack_require__.p = "https://adminfront-neom.pages.dev/";